module.exports = __webpack_public_path__ + "img/1-2.40eab822.png";